import { Component, OnInit } from '@angular/core';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { TransactionHistoryService } from '../../_services/transaction/transaction-history.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { ErrorPopupComponent } from '../../sharedcomponents/_directive/error-popup/error-popup.component';
import { UserStateService } from '../../_services/userservice/userstateservice';
import * as _ from 'lodash';
@Component({
  selector: 'app-transaction-list',
  templateUrl: './transaction-list.component.html',
  styleUrls: ['./transaction-list.component.css'],
  providers: [Modal]
})
export class transactionlistcomponent implements OnInit {
  pageMode = 'repeatorder';
  transcationlist: any = [];
  isFirstLoad = true;
  userDetail: any = {};
  constructor(
    public utilserv: utilityService,
    private router: Router,
    public transHistory: TransactionHistoryService,
    public translate: TranslateService,
    public modal: Modal,
    private userStateService: UserStateService
  ) {}

  ngOnInit() {
    this.userStateService.getcurrentUserDetailData().subscribe(data => {
      this.userDetail = data;
    });
    if (this.userDetail.IsBeingLinked == 'true') {
      this.getTranscationList('', '');
    } else {
      this.isFirstLoad = false;
    }
  }

  getTranscationList(orderid, beneficiaryid) {
    this.utilserv.busy = this.transHistory.gettransactionlistservice(orderid, beneficiaryid).subscribe(data => {
      const response = data.Envelope.Body.OutGoingTransactionResponse;
      this.isFirstLoad = false;
      if (response.StatusCode == enumStatusCodeList.TokenInvalidOrExpired) {
        return false;
      }
      if (response.StatusCode == enumStatusCodeList.SUCCESS) {
        this.transcationlist = this.utilserv.getArray(response.BeneficiaryTransactions.BeneficiaryTransaction);
        // this.transcationlist = _.sortBy(this.transcationlist, 'RecentOrderDate').reverse();

        this.transcationlist = this.sortByDate(this.transcationlist);
      } else {
        this.translate.use(sessionStorage.langCode).subscribe(data => {
          let modalData: any = {};
          modalData.Title = this.translate.instant('Common_lblOops');
          modalData.Message = response.StatusMessage;
          this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
        });
      }
    });
  }

  sortByDate(myArray): void {
    return myArray.sort((a, b) => {
        return new Date( this.utilserv.getObjectText(b.RecentOrderDate)).getTime() - new Date(this.utilserv.getObjectText(a.RecentOrderDate)).getTime();

    });
}

  openusertranscation(BeneficiaryData) {
    this.transHistory.settransactionhistoryData(BeneficiaryData);
    this.router.navigate(['/transactionuserlist']);
    return;
  }
  errorPopup() {
    let modalData: any = {};
    const _self = this;
    modalData.Title = this.translate.instant('Common_lblOops').toString();
    modalData.Message = this.translate.instant('Message_dataNotFound');
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {
        // _self.router.navigate(['/dashboard']);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/transaction-history/transaction-list/transaction-list.component.ts